import { Component, OnInit, AfterViewInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MainService } from '../service/main.service';
import { ProfileService } from '../service/profile.service';
import { AuthenticationService } from '../../authentication.service';
// import { TaskService } from '../service/task.service';
import { Router } from '@angular/router';
// import { matDatepickerAnimations } from '@angular/material';
// import { NgxSpinnerService } from 'ngx-spinner';
// import { DataAccessService } from '../../hrms/service/data-access.service';
import { LogService } from '../service/log.service';
import Swal from 'sweetalert2';
import { session } from '../../../environments/environment.session'
import { SpinnerService } from '../../shared/spinner.service'
import { MainService as MainServicep } from '../../portal/service/main.service'
import { Utf8EncodingService } from 'src/app/md/service/utf8-encoding.service';
// import { importType } from '@angular/compiler/src/output/output_ast';
//  import {session} from '../../../environments/environment.session'

@Component({
  selector: 'app-portal-dash',
  templateUrl: './portal-dash.component.html',
  styleUrls: ['./portal-dash.component.css']
})
export class PortalDashComponent implements OnInit {
  erpUser: any;
  constructor(private mainServicep: MainServicep, private tspinner: SpinnerService, private log: LogService,
    public auth: AuthenticationService, private profileService: ProfileService, private router: Router,
    private mainService: MainService, private utf8EncodingService: Utf8EncodingService) {
    try {
      this.erpUser = utf8EncodingService.decodeFromUtf8((session['erpUser']));
    } catch (error) {
      if (sessionStorage.getItem('1001') == undefined || sessionStorage.getItem('1001') == null) {
        this.router.navigate(['/login']);
      }
    }

  }

  url: any = {
    'HR': 'hrms', ACCOUNT: 'accounts', AA: 'md', SA: 'solution-admin', ACMS: 'acms'
  };
  imgUrl: any = {
    'HR': 'hrms.png', ACCOUNT: 'ap.png', 'SA': 'admin.png', 'AA': "md.png", ACMS: 'acms.png'
  };

  assignedProducts: any = [];
  activeProducts: any = {};
  col1: any = [];
  col2: any = [];
  col3: any = [];
  empObj: any = {};
  personalInfoObj: any = {};
  allPosting: any = [];
  allApproval: any = [];
  allDocument: any = [];
  postingObj: any = {};
  approvalObj: any = {};
  allApprovalStatus: any = [];
  hr_flag: any = false;
  account_flag: any = false;


  is_admin: any = 0
  pr: any = [];
  async ngOnInit() {



    this.tspinner.show('', '')


    // if (this.erpUser['b_acct_id'] != 0) {
    //   await this.getAllAssignedComponent(this.erpUser.b_acct_id, this.erpUser.role_cd);
    // }

    // 
    // await this.auth.getSystemModule();
    if (this.erpUser) {


      this.pr = await this.auth.getAssignModules(this.erpUser.b_acct_id, this.erpUser.role_cd)
      this.erpUser.module_cd = []
      let temp: any = []
 

      this.pr.map((x: any) => {
        // if(this.productToShow.includes(x['module_cd'])){
        temp.push(x)
        this.erpUser.module_cd.push(x['module_cd'])
        // }
      })
      this.pr = temp

      session.erpUser = this.utf8EncodingService.encodeToUtf8((JSON.stringify(this.erpUser)))
      if (this.erpUser['b_acct_id'] == 0) {
        this.router.navigate(['/solution-admin/index'])
      }
   

      // erpUser['assigned_component'] = this.allComponentCode;
      // session.erpUser=btoa(JSON.stringify(erpUser))
      // sessionStorage.setItem('erpUser', btoa(JSON.stringify(erpUser)));
      this.is_admin = this.erpUser['is_admin'];
      this.erpUser = this.utf8EncodingService.decodeFromUtf8((session['erpUser']));

      // this.assignedProducts = this.erpUser.module_cd;
      // if (this.assignedProducts == undefined) {
      //   this.assignedProducts = []
      // }
      // for (var i = 0; i < this.assignedProducts.length; i++) {
      //   if (this.assignedProducts[i] == 'NA') {
      //     continue;
      //   }
      //    if(this.productToShow.includes(this.assignedProducts[i]))// code define module
      //   this.pr.push(this.assignedProducts[i]);
      // }

      if (this.pr.length == 1) {
        await this.route(this.pr[0]['module_cd'])
      }
      if (this.erpUser['role_cd'].includes('DIRECTOR') || this.erpUser['role_cd'].includes('Dir')) {
        this.pathToDashBoard = true;
      }
      this.tspinner.hide()
    }
  }

  async getErpUser() {
    let obj = {}
    let resp = await this.auth.getErpUser((obj))
    if (resp['error'] == false) {
      this.erpUser = resp['data'][0]['erpUser']
      // session.erpUser = btoa(resp['data'][0]['erpUser'])
      session.erpUser = this.utf8EncodingService.encodeToUtf8((JSON.stringify(this.erpUser)))
    } else {
      Swal.fire('Error', resp['data'], 'error')
    }
  }

  pathToDashBoard: any = false;
  // allComponentCode :any= []
  // async getAllAssignedComponent(b_acct_id:any, role_cd:any) {
  //   this.tspinner.show('','')
  //   var obj :any= new Object();
  //   obj['b_acct_id'] = b_acct_id;
  //   obj['role_cd'] = role_cd;

  //   var resp = await this.mainService.getAllAssignedComponents(JSON.stringify(obj));
  //   if (resp['error'] == false) {
  //     this.tspinner.hide()
  //     var allComponentCode = [];
  //     let dummy = []
  //     for (let i = 0; i < resp['data'].length; i++) {
  //       dummy.push(resp['data'][i]['resource_cd'])
  //     }
  //     this.allComponentCode = dummy
  //   } else {
  //     this.tspinner.hide()
  //     Swal.fire('Error', 'Error While Getting All Resource', 'error')
  //   }
  //   // }
  // }




  async route(i: any) {
    this.log.module_cd = this.url[i]
    this.log.le_id = this.erpUser.le_id
    await this.getAllAssignedComponent(this.erpUser.b_acct_id, this.erpUser.role_cd, [i])
    this.router.navigate(['/' + this.url[i] + "/" + this.url[i] + "-index"])
  }


  async getAllAssignedComponent(b_acct_id: any, role_cd: any, module_cd: any) {
    this.tspinner.show('', '')
    // Always initialise assigned_component so AcmsSidebarComponent constructor never crashes
    if (!this.erpUser.assigned_component) {
      this.erpUser.assigned_component = [];
    }
    try {
      var obj: any = new Object();
      obj['b_acct_id'] = b_acct_id;
      obj['role_cd'] = role_cd;
      obj['module_cd'] = module_cd;
      var resp = await this.mainServicep.getAllAssignedComponents(JSON.stringify(obj));
      if (resp['error'] == false) {
        this.erpUser.assigned_component = []
        for (let i = 0; i < resp['data'].length; i++) {
          if (!this.erpUser.assigned_component.includes(resp['data'][i]['resource_cd']))
            this.erpUser.assigned_component.push(resp['data'][i]['resource_cd'])
        }
      }
    } catch (err) {
      console.error('getAllAssignedComponent error:', err);
    } finally {
      // Always persist updated erpUser (with assigned_component) so sidebar never crashes
      session.erpUser = this.utf8EncodingService.encodeToUtf8((JSON.stringify(this.erpUser)))
      this.tspinner.hide()
    }
  }


  portal(params: any) {
    this.router.navigate(['/' + params])
  }

  async getEmpInfo() {
    var resp = await this.profileService.getUserProfileInfo(this.erpUser.user_id);
    if (resp['error'] == false) {
      this.empObj = resp['data'][0];
      var erp = this.erpUser;
      erp['User_name'] = this.empObj['first_name'] + " " + this.empObj['last_name'];
      session.erpUser = this.utf8EncodingService.encodeToUtf8((JSON.stringify(erp)));
    } else {
      Swal.fire('Error', resp['data'], 'error')
    }
  }


  async getEstablishmentInfo() {
    this.tspinner.show('', '')
    var obj: any = new Object();
    obj['b_acct_id'] = this.erpUser.b_acct_id;
    obj['email'] = this.empObj['email'];
    obj['phone_no'] = this.empObj['work_phone_no'];

    if (this.erpUser.b_acct_id != 0) {
      var resp: any = await this.profileService.getEstablishmentInfo(JSON.stringify(obj));
      if (resp['error'] == false) {
        this.tspinner.hide()
        if (resp['data'].length > 0) {
          this.personalInfoObj = resp['data'][0];
          this.mainService.emp_id = this.personalInfoObj['emp_id'];
        }

      } else {
        this.tspinner.hide()

      }
    }

  }

  // async getAllPosting() {
  //   var obj = new Object();
  //   obj['b_acct_id'] = this.erpUser.b_acct_id;
  //   obj['emp_id'] = this.personalInfoObj['emp_id'];
  //   var resp = await this.profileService.getPostingInfo(obj);
  //   if (resp['error'] == false) {
  //     var dt = resp['data'];
  //     for (var i = 0; i < dt.length; i++) {
  //       if (dt[i]['posting_end_date'] == '2090-10-10') {
  //         this.allPosting.push(dt[i]);
  //         this.postingObj[dt[i]['section_code'] + dt[i]['designation_code']] = 1;
  //       }
  //     }
  //   } else {
  //     // this.snackBar.open('Error','Error while getting all posting');
  //   }
  // }
  // async getAllApproval() {
  //   var resp = await this.profileService.getAllApproval(this.erpUser.b_acct_id);
  //   if (resp['error'] == false) {
  //     this.allApproval = resp['data'];


  //     if(Object.keys(this.postingObj).length>0){


  //       for (var i = 0; i < this.allApproval.length; i++) {
  //         if (this.postingObj[this.allApproval[i]['section_code'] + this.allApproval[i]['designation_code']] == 1 ) {
  //           if (this.approvalObj[this.allApproval[i]['doc_type']] == undefined) {
  //             this.approvalObj[this.allApproval[i]['doc_type']] = []
  //           }
  //           this.approvalObj[this.allApproval[i]['doc_type']].push(this.allApproval[i]['level_of_approval']);
  //         }
  //       }


  //     }


  //   } else {
  //     this.snackBar.open('Error', 'Error while getting all Approval');
  //   }
  // }
  // async getAllApprovalStatus() {
  //   var obj1 = new Object();
  //   obj1['b_acct_id'] = this.erpUser.b_acct_id;
  //   var resp = await this.profileService.getAllApprovalStatus(obj1);
  //   var count = 0;
  //   if (resp['error'] == false) {
  //     this.allApprovalStatus = resp['data'];
  //     var obj = {};


  //     if(Object.keys(this.approvalObj).length>0){


  //       for (var i = 0; i < this.allApprovalStatus.length; i++) {
  //         if (this.allApprovalStatus[i]['status'] == 'PENDING' && this.approvalObj[this.allApprovalStatus[i]['doc_type']].indexOf(this.allApprovalStatus[i]['level_of_approval']) > -1) {
  //           var lvl = this.approvalObj[this.allApprovalStatus[i]['doc_type']];
  //           if (lvl == '1') {
  //             count++;
  //           } else if (obj[this.allApprovalStatus[i]['doc_local_no'] + "" + (parseInt(this.allApprovalStatus[i]['level_of_approval']) - 1)] == 'APPROVED') {
  //             count++;
  //           }
  //         }
  //         obj[this.allApprovalStatus[i]['doc_local_no'] + this.allApprovalStatus[i]['level_of_approval']] = this.allApprovalStatus[i]['status'];
  //       }


  //     }

  //     this.mainService.tasks = count;
  //     this.taskService.approvalObj = this.approvalObj;
  //   } else {
  //     this.snackBar.open(resp['data'], 'Error', {
  //       duration: 5000,
  //     });
  //   }
  // }



  //************************************************************************************* */
  allTaskArr: any = []
  lastLevelOfApprovel: any = {};
  async getAllRule() {
    var resp: any = await this.profileService.getAllApproval(this.erpUser.b_acct_id);
    if (resp['error'] == false) {
      this.allApproval = resp['data'];
      for (var i = 0; i < this.allApproval.length; i++) {
        this.lastLevelOfApprovel[this.allApproval[i]['doc_type']] = this.allApproval[i]['level_of_approval']
      }
    } else {

    }

  }

  stepStatus: any = {};
  async getAllApprovalStatus() {

    this.mainService.tasks = 0;
    this.stepStatus = {};
    this.allTaskArr = [];
    var ob: any = new Object();
    ob['b_acct_id'] = this.erpUser.b_acct_id;
    var resp = await this.profileService.getAllApprovalStatus(ob);
    var unique_local_no = [];

    if (resp['error'] == false) {
      this.allApprovalStatus = resp['data'];

      var temp = [];
      for (let i = 0; i < this.allApprovalStatus.length; i++) {
        this.stepStatus[this.allApprovalStatus[i]['doc_local_no'] + this.allApprovalStatus[i]['level_of_approval']]
          = this.allApprovalStatus[i]['status']
        if (this.allApprovalStatus[i]['user_id'] == this.erpUser['user_id']) {
          temp.push(this.allApprovalStatus[i]);
          unique_local_no.push(this.allApprovalStatus[i]['doc_local_no']);
        }
      }

      this.allApprovalStatus = [];
      this.allApprovalStatus = temp;
      let unique = unique_local_no.filter((item, i, ar) => ar.indexOf(item) === i);

      var tableObj: any = {}
      for (let j = 0; j < unique.length; j++) {
        for (var i = 0; i < this.allApprovalStatus.length; i++) {
          if (this.allApprovalStatus[i]['status'] == 'APPROVED' || this.allApprovalStatus[i]['status'] == 'REJECTED') {
            var obj1 = Object.assign({}, this.allApprovalStatus[i]);
            obj1['action'] = 0;
            obj1['last_approval_level'] = this.lastLevelOfApprovel[this.allApprovalStatus[i]['doc_type']];
            tableObj[this.allApprovalStatus[i]['doc_local_no'] + this.allApprovalStatus[i]['level_of_approval']] = obj1;
          } else {
            var obj1 = Object.assign({}, this.allApprovalStatus[i]);
            if (this.allApprovalStatus[i]['level_of_approval'] == 1) {
              obj1['action'] = 1;
              obj1['last_approval_level'] = this.lastLevelOfApprovel[this.allApprovalStatus[i]['doc_type']];
              tableObj[this.allApprovalStatus[i]['doc_local_no'] + this.allApprovalStatus[i]['level_of_approval']] = obj1;
            }
            else if (this.stepStatus[this.allApprovalStatus[i]['doc_local_no'] + ((this.allApprovalStatus[i]['level_of_approval']) - 1)] == 'PENDING') {
              obj1['action'] = 0;
              obj1['last_approval_level'] = this.lastLevelOfApprovel[this.allApprovalStatus[i]['doc_type']];
              tableObj[this.allApprovalStatus[i]['doc_local_no'] + this.allApprovalStatus[i]['level_of_approval']] = obj1;
            } else {
              obj1['action'] = 1;
              obj1['last_approval_level'] = this.lastLevelOfApprovel[this.allApprovalStatus[i]['doc_type']];
              tableObj[this.allApprovalStatus[i]['doc_local_no'] + this.allApprovalStatus[i]['level_of_approval']] = obj1;
            }
          }
        }
      }



      var keys = Object.keys(tableObj);
      var tt = [];
      for (let i = 0; i < keys.length; i++) {
        tt.push(tableObj[keys[i]])
      }

      for (let j = 0; j < unique.length; j++) {
        var tt1;
        for (let i = 0; i < tt.length; i++) {
          if (tt[i]['doc_local_no'] == unique[j]) {
            if (tt[i]['action'] == 1) {
              tt1 = tt[i];
              this.allTaskArr.push(tt1)
              break;
            } else {
            }

          }
        }
      }


      this.mainService.tasks = this.allTaskArr.length;
    } else {
    }
  }


}
